import BaseUI from "../base-ui.ts";
import LogoFragment from "../fragments/logo.ts";
import State from "../../state/state.ts";
import EatOutApiClient from "../../api-client/eat-out-api-client.ts";
import V1UserGuestLoggedIn from "../../payloads/incoming/v1-user-guest-logged-in.ts";
import UiUtils from "../../utils/ui-utils.ts";
import Route from "../../enums/route.ts";
import LogUtils from "../../utils/log-utils.ts";
import SharedApiLogic from "../../api-client/shared-api-logic.ts";

export default class ChooseNicknameScreen extends BaseUI {
  constructor(state: State, apiClient: EatOutApiClient, navigateCallback: (route: Route) => void) {
    super("choose-nickname-screen", state, apiClient, navigateCallback);

    // subscribe to events
    this.apiClient.v1GuestUserLoggedInCallback = this.handleV1UserGuestLoggedIn.bind(this);

    // reset "current group" to nothing
    this.state.groupState.currentGroupId = null;
  }

  public override render(newElements: HTMLElement[] = []): HTMLDivElement {
    // logo
    const logo: LogoFragment = new LogoFragment(this.state, this.apiClient, this.navigateCallback);
    newElements.push(logo.render());

    // form
    const form: HTMLFormElement = UiUtils.form(this.handleFormSubmitEvent.bind(this));
    newElements.push(form);

    // nickname input
    const nicknameLabel: HTMLLabelElement = UiUtils.label("Enter your name ", "nickname");
    form.appendChild(nicknameLabel);
    const nicknameInput: HTMLInputElement = UiUtils.inputText("nickname");
    form.appendChild(nicknameInput);

    // submit button
    const chooseNicknameButton: HTMLButtonElement = UiUtils.button("Ready!");
    form.appendChild(chooseNicknameButton);

    return super.render(newElements);
  }

  private handleFormSubmitEvent(event: SubmitEvent): void {
    // make sure the event's target was truly an HTMLFormElement
    const eventTarget: EventTarget | null = event.target;
    if (!(eventTarget instanceof HTMLFormElement)) {
      LogUtils.error(
        `attempted to parse form submit event, but the event's target was a ${typeof eventTarget} when we expected an HTMLFormElement`,
      );
    }

    // get nickname from form
    const formData: FormData = new FormData(eventTarget);
    if (!formData.has("nickname")) {
      LogUtils.error("attempted to get nickname from Choose Nickname form, but it doesn't exist");
    }
    const nickname: FormDataEntryValue | null = formData.get("nickname");
    if (typeof nickname !== "string") {
      LogUtils.error(
        `attempted to retrieve nickname from Choose Nickname form, but it was a ${typeof nickname} when we expected a string`,
      );
    }

    // attempt login
    this.apiClient.sendLoginGuestUserPayload(nickname);
  }

  private handleV1UserGuestLoggedIn(v1UserGuestLoggedIn: V1UserGuestLoggedIn): void {
    SharedApiLogic.handleV1UserGuestLoggedIn(this.debug, this.state, this.navigateCallback, v1UserGuestLoggedIn);
  }
}
